
      import API from "!../../../../cli-app/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../cli-app/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      
      import setAttributes from "!../../../../cli-app/node_modules/style-loader/dist/runtime/setAttributesWithAttributesAndNonce.js";
      import insertStyleElement from "!../../../../cli-app/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../cli-app/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../cli-app/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[10].use[1]!../../../../cli-app/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[10].use[2]!../../../../cli-app/node_modules/source-map-loader/dist/cjs.js!./BurgerMenu.module.css";
      
      

var options = {"attributes":{}};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = function anonymous(linkTag
) {

  if (!window.__JUTRO_SHELL_CONTEXT_LOADED__) {
      window.__JUTRO_SHELL_CONTEXT_LOADED__ = true;
      if("") {
        document.body.classList.add("");
      }
    }
    linkTag.setAttribute("data-jutro-css-scope", "");

    var isThemeBase = linkTag.tagName === 'STYLE' && linkTag.getAttribute('data-jutro-styles') === 'themeBase';
    if (isThemeBase) {
      document.head.insertBefore(linkTag, document.head.firstChild);
      return;
    }

    var lastElementForCssScope = document.head.querySelector("[data-jutro-css-scope='']:last-of-type");
    if (lastElementForCssScope) {
      lastElementForCssScope.after(linkTag);
    } else {
      document.head.appendChild(linkTag);
    }
  
};
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../cli-app/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[10].use[1]!../../../../cli-app/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[10].use[2]!../../../../cli-app/node_modules/source-map-loader/dist/cjs.js!./BurgerMenu.module.css";
       export default content && content.locals ? content.locals : undefined;
